// Lê o `exp` (em segundos) do JWT sem validar a assinatura: só serve para avisar o usuário
export const tokenExpiresAt = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.exp ? payload.exp * 1000 : null;
    } catch {
        return null;
    }
};

export const isTokenExpired = (token, skewMs = 5000) => {
    const exp = tokenExpiresAt(token);
    return exp !== null && exp - skewMs <= Date.now();
};
